import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67b67f29&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67b67f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b67f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b67f29')) {
      api.createRecord('67b67f29', component.options)
    } else {
      api.reload('67b67f29', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67b67f29&scoped=true&", function () {
      api.rerender('67b67f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/goodsManagement/index.vue"
export default component.exports